<template>
    <div class="marriage-record-item" @click.passive="clickRecordItem">
        <div class="marriage-record-item-content dsp-flex">
            <div class="marriage-record-text">
                <p class="text-name">{{ source.f_first_name }}</p>
                <p class="text-time">{{ source.f_first_gender == 0 ? '男' : '女' }} {{ MOMENT_TIME.getFormateTimeYMDHmByTimeStamp(source.f_first_bday*1000) }}</p>
            </div>
            <div class="marriage-record-text" v-if="source.f_type != 1">
                <p class="text-name">{{ source.f_second_name }}</p>
                <p class="text-time">{{ source.f_second_gender == 0 ? '男' : '女' }} {{ MOMENT_TIME.getFormateTimeYMDHmByTimeStamp(source.f_second_bday*1000) }}</p>
            </div>
        </div>
        <div class="marriage-record-sub-text" v-if="source.f_create_time">{{ UTILS.getChineseTimeYMDHmByTimeStamp(source.f_create_time) }}</div>
        <div class="marriage-record-status status1">{{ statusList[source.f_type-1] }}</div>
    </div>
</template>

<script>
import { MOMENT_TIME } from '../../modules/momenttime';
import { MIX, UTILS } from '../../modules/utils';
export default {
    name: 'MarriageRecordItem',
    props: {
        source: {
            type: Object,
            default() { return {} }
        },
    },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            MOMENT_TIME: MOMENT_TIME,
            statusList: ['个人姻缘', '二人姻缘', '综合测算', '年运专测']
        }
    },
    methods: {
        clickRecordItem() {
            console.log('clickRecordItem', this.source);
            if(this.source.f_verify == 0) {
                this.$store.state.marriage.marriageData = this.source;
                this.$router.replace('/marriageverify');
            }else if(this.source.f_verify == 1) {
                this.$store.dispatch('marriage/getMarriageFavorableInfoById', {
                    rData: this.source,
                    sucCb: ()=> {
                        this.goToPage();
                    }
                })
            }
        },
        goToPage() {
            switch(this.source.f_type) {
                case 1:
                    this.$router.replace('/marriagereportone/'+this.source.id);
                    break;
                case 2:
                    this.$router.replace('/marriagereporttwo/'+this.source.id);
                    break;
                default:
                    break;
            }
        }
    }
}
</script>